import { render } from "./Bustour_asso.vue?vue&type=template&id=5e0a7992&scoped=true"
import script from "./Bustour_asso.vue?vue&type=script&lang=js"
export * from "./Bustour_asso.vue?vue&type=script&lang=js"

import "./Bustour_asso.vue?vue&type=style&index=0&id=5e0a7992&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0a7992"]])

export default __exports__